import { useEffect, useState } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { useSignMessage } from "wagmi";
import { AUTHENTICATE_MUTATION, CHALLENGE_QUERY, FOLLOWING, USER_PROFILES_QUERY, } from "../../graphql";
const ERROR_MESSAGE = "Something went wrong!";
// @ts-ignore
export const useLensAuth = ({ walletAddress }, deps = []) => {
    const [hasProfile, setHasProfile] = useState(false);
    const [profiles, setProfiles] = useState([]);
    const [following, setFollowing] = useState();
    const [currentProfile, setCurrentProfile] = useState();
    const [profileId, setProfileId] = useState("");
    const [getProfiles, { error: errorProfiles, loading: profilesLoading }] = useLazyQuery(USER_PROFILES_QUERY);
    const [getFollowing, { error: errorFollowing, loading: profilesFollowing }] = useLazyQuery(FOLLOWING);
    const [loadChallenge, { error: errorChallenge, loading: challengeLoading }] = useLazyQuery(CHALLENGE_QUERY, {
        fetchPolicy: "no-cache",
    });
    const { signMessageAsync, isLoading: signLoading } = useSignMessage({
        onError: (err) => console.error("Error: ", err.message),
    });
    const [authenticate, { error: errorAuthenticate, loading: authLoading }] = useMutation(AUTHENTICATE_MUTATION);
    const signIn = async () => {
        try {
            // Get challenge
            const challenge = await loadChallenge({
                variables: { request: { address: walletAddress } },
            });
            if (!challenge?.data?.challenge?.text) {
                return console.error(ERROR_MESSAGE);
            }
            // Get signature
            const signature = await signMessageAsync({
                message: challenge?.data?.challenge?.text,
            });
            // Auth user and set cookies
            const auth = await authenticate({
                variables: { request: { address: walletAddress, signature } },
            });
            localStorage.setItem("accessToken", auth.data.authenticate.accessToken);
            localStorage.setItem("refreshToken", auth.data.authenticate.refreshToken);
            // Get authed profiles
            const { data: profilesData } = await getProfiles({
                variables: { ownedBy: walletAddress },
            });
            // Get Following
            const request = { address: walletAddress, limit: 10 };
            const { data: followingsData } = await getFollowing({
                variables: { request },
            });
            if (profilesData?.profiles?.items?.length === 0) {
                setHasProfile(false);
            }
            else {
                const profiles = profilesData?.profiles?.items
                    ?.slice()
                    ?.sort((a, b) => Number(a.id) - Number(b.id))
                    ?.sort((a, b) => !(a.isDefault !== b.isDefault) ? 0 : a.isDefault ? -1 : 1);
                const currentProfile = profiles[0];
                setProfiles(profiles);
                setCurrentProfile(currentProfile);
                setProfileId(currentProfile.id);
                setFollowing(followingsData);
            }
        }
        catch { }
    };
    useEffect(() => {
        if (walletAddress) {
            signIn();
        }
    }, [walletAddress, ...deps]);
    return { following, profiles, currentProfile, profileId };
};
